import React, { useState, useEffect, useRef } from "react";
import { MediaUrl, getUserInfo, setCookiesUser, removeCookies, getCookies } from "../../utils/configuration";
import { TOKEN_KEY, REFRESH_TOKEN_KEY, URL_RETURN_KEY } from "../../config/common";
import { Dialog } from "@mui/material";
import history from "../../common/history";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "../../models/schema/auth";
import authSvc from "../../services/api/auth";
import { LoginRequest } from "../../models/types/auth";
import InputField from "../form-input/InputField";
// --- icon ---
import { LoaderCircle } from "lucide-react";

const LockScreen = () => {
    const user = getUserInfo();
    const intervalCheckLockScreen = useRef<NodeJS.Timeout | number>(0);

    const [isShowLockScreen, setIsShowLockScreen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onBlur",
        resolver: yupResolver(loginSchema),
        defaultValues: {
            email: user ? user.email : "",
        }
    });

    const onSubmit = async (data: LoginRequest) => {
        if (!data) return;
        setIsLoading(true);
        try {
            const res = await authSvc.login({ ...data, returnUrl: '/' });
            if (res && res.content) {
                setCookiesUser(res.content);
                removeCookies("isShowDialog");
                removeCookies("isLockScreen");
                setIsShowLockScreen(false);
            }
            setIsLoading(false);
        }
        catch (e) {
            console.error('Login error:', e);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        intervalCheckLockScreen.current = setInterval(() => {
            if (getUserInfo() && getCookies("isLockScreen") === "true") {
                setIsShowLockScreen(true);
            }
        }, 1000);

        return () => clearInterval(intervalCheckLockScreen.current);
    }, []);

    const onLogout = () => {
        history.push("/login");
        removeCookies("isShowDialog");
        removeCookies("isLockScreen");
        removeCookies(TOKEN_KEY);
        removeCookies(REFRESH_TOKEN_KEY);
        removeCookies(URL_RETURN_KEY);
        setIsShowLockScreen(false);
    };

    return (
        <Dialog
            open={isShowLockScreen}
            onClose={() => { }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullScreen
        >
            <div className="lock-screen-wraper min-h-screen flex flex-col items-center justify-center bg-gray-100">
                <div className="w-full max-w-md p-6 ">
                    <h2 className="text-3xl font-bold text-center">
                        <img
                            src={MediaUrl + user?.avatar}
                            alt="avatar"
                            className="h-36 w-36 rounded-full mx-auto"
                            onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = '/assets/images/user-avatar.png';
                            }}
                        />
                        <span className="text-gray-800">{user?.fullName}</span>
                    </h2>

                    <form
                        className="mt-8 space-y-6"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <InputField
                            name="password"
                            type="password"
                            register={register}
                            error={errors.password}
                            required={true}
                            placeholder="Password"
                        />

                        <div className="flex gap-4">
                            <button
                                type="submit"
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                disabled={isLoading}
                            >
                                {isLoading ? <LoaderCircle className="animate-spin mr-2" /> : "Login"}
                            </button>
                            <button
                                type="button"
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                onClick={onLogout}
                            >
                                Đăng xuất
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Dialog>
    )
}

export default LockScreen;